export { default } from "./SimpleBarChart";



// WEBPACK FOOTER //
// ./src/components/SimpleBarChart/index.ts